import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface FontFamilySelectProps {
  value?: string;
  onChange: (font: string) => void;
  disabled?: boolean;
}

const fonts = [
  { value: 'Arial', label: 'Arial' },
  { value: 'Georgia', label: 'Georgia' },
  { value: 'Times New Roman', label: 'Times New Roman' },
  { value: 'Trebuchet MS', label: 'Trebuchet MS' },
  { value: 'Verdana', label: 'Verdana' },
  { value: 'Courier New', label: 'Courier New' },
  { value: 'Tahoma', label: 'Tahoma' },
  { value: 'Palatino Linotype', label: 'Palatino' },
];

const FontFamilySelect: React.FC<FontFamilySelectProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  return (
    <Select value={value || ''} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger className="w-[120px] h-8 text-xs">
        <SelectValue placeholder="Font" />
      </SelectTrigger>
      <SelectContent>
        {fonts.map((font) => (
          <SelectItem
            key={font.value}
            value={font.value}
            style={{ fontFamily: font.value }}
          >
            {font.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default FontFamilySelect;
